


















import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'SorewardsRateField'
})
export default class extends Vue {
  @Prop({ required: true }) private label!: string
  @Prop({ required: true }) private note!: string
  @Prop({ default: false }) private editing!: boolean
  @Prop({ required: true }) private display!: string
  @Prop({ required: true }) private value!: number
  @Prop({ default: false }) private percent!: boolean

  private onChange(next: number) {
    this.$emit('update:value', next == null ? 0 : next)
  }
}
